import React from 'react';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { useDeleteTemplateMutation } from '../../api/useDeleteTemplateMutation';

interface Props {
  onClose: () => void;
  id: string;
  name: string;
}

export const DeleteModal = ({ onClose, id, name }: Props) => {
  const {
    mutateAsync: deleteTemplate,
    isLoading: isDeleting,
    error: deleteError,
  } = useDeleteTemplateMutation();

  return (
    <Modal isOpen onRequestClose={() => onClose()} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        Delete Template?
      </ModalHeader>
      <ModalCloseButton onClick={() => onClose()} />

      <ModalBody>
        {deleteError && (
          <Alert variant="error" mb="16">
            {deleteError.message}
          </Alert>
        )}
        Are you sure you want to delete {name}? Once you delete the template, it cannot be undone.
      </ModalBody>

      <ModalFooter css={({ theme }) => ({ gap: theme.space['8'] })}>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          isLoading={isDeleting}
          disabled={isDeleting}
          onClick={async () => {
            try {
              await deleteTemplate({ templateId: id });

              onClose();
            } catch (e) {
              console.error(e);
            }
          }}
        >
          Confirm Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
